import React from "react";
import { Modal, Divider } from "antd";
import styles from "./report-card-modal.module.css";
import ExamReportView from "./components/exam-report-view/exam-report-view";

const ReportCardModal = ({
  visible,
  onClose,
  studentId,
  examDetails,
  handleBack,
  isECDProgram,
  selectedTerm,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      title={
        <>
          <div className={styles.modalTitle}>Report Card</div>
          <Divider className={styles.modalTitleDivider} />
        </>
      }
    >
      <ExamReportView 
        studentId={studentId}
        selectedExam={{
          id: examDetails?.id,
          title: examDetails?.name,
          date: examDetails?.start
        }} 
        handleBack={handleBack}
        isECDProgram={isECDProgram}
        selectedTerm={selectedTerm}
      />
    </Modal>
  );
};

export default ReportCardModal;
